import { useMemo } from 'react';
import { Page } from '@/types/page';
import { usePageContext } from '@/hooks/usePageContext';

export const usePageFiltering = () => {
  const { pages } = usePageContext();

  return useMemo(() => {
    // First filter enabled pages
    const enabledPages = pages.filter(page => page.enabled);
    
    // Then split by position
    const leftPages = enabledPages.filter(page => page.position === 'left' || !page.position);
    const rightPages = enabledPages.filter(page => page.position === 'right');
    const fullscreenPages = enabledPages.filter(page => page.position === 'fullscreen');

    console.log('Filtered pages:', { 
      total: pages.length,
      enabled: enabledPages.length,
      left: leftPages.length, 
      right: rightPages.length, 
      fullscreen: fullscreenPages.length 
    });

    return {
      enabledPages,
      leftPages,
      rightPages,
      fullscreenPages
    };
  }, [pages]);
};
